module.exports = __webpack_public_path__ + "img/1-4.f8ad46ff.svg";